import React, { createContext, useContext, useState, useCallback } from "react";
import { translations, LANGS } from "@/i18n/translations";

const I18nContext = createContext(null);

function resolve(obj, path) {
  return path.split(".").reduce((acc, k) => (acc && acc[k] != null ? acc[k] : null), obj);
}

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("dc_lang") || "es");

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("dc_lang", l);
  }, []);

  const t = useCallback(
    (key) => {
      const val = resolve(translations[lang], key);
      if (val != null) return val;
      const fallback = resolve(translations.es, key);
      return fallback != null ? fallback : key;
    },
    [lang]
  );

  return (
    <I18nContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
